import { t } from 'i18next';

export type RankedEntry = {
  label: string;
  count: number;
};

/**
 * Ranks labelled counts and caps them at `limit`, summing the tail into a final
 * `Other (N)` entry (worded by `metrics:overflow`). The endpoint applies no limit, so dropping
 * the tail is not an option. A category the payload really calls `Other` keeps its rank
 * rather than joining the fold.
 */
export function rankAndFold(counts: Record<string, number | null>, limit: number): RankedEntry[] {
  const ranked = Object.entries(counts)
    .map(([label, count]) => ({ label, count: count ?? 0 }))
    .sort((a, b) => b.count - a.count || a.label.localeCompare(b.label));

  if (ranked.length <= limit) return ranked;

  const tail = ranked.slice(limit - 1);

  return [
    ...ranked.slice(0, limit - 1),
    {
      label: t('metrics:overflow', { hidden: tail.length }),
      count: tail.reduce((sum, entry) => sum + entry.count, 0),
    },
  ];
}
